module.exports = __webpack_public_path__ + "static/media/chess-board.d0c303a2.svg";